export default __webpack_public_path__ + "static/media/helsinki_m.633b0cf9.jpg";